import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { on } from '@ember/modifier';
import filterSort from 'bcl/helpers/filter-sort';
import eq from 'ember-truth-helpers/helpers/eq';

interface InputSelectSuppliersSignature {
  // The arguments accepted by the component
  Args: {
    // The name of the input field
    name: string;
    // The label for the input field
    label: string;
    // The value of the input field, expected to be a supplier model
    value: { id: string; name: string };
    // Callback function to handle changes in the select input
    onChange?: (value: { id: string; name: string }) => void;
    // Force update trigger, can be used to refresh the component
    forceUpdate?: number;
    // hide special supplier from list
    hide_special?: boolean;
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: null;
}

export default class InputSelectSuppliersComponent extends Component<InputSelectSuppliersSignature> {
  <template>
    {{! this is used to set the select to the correct value }}
    {{this._forceUpdate}}
    <div
      class="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-2 col-span-6"
    >
      <label
        for={{@name}}
        class="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5 sm:text-right"
      >{{@label}}</label>
      <div class="mt-2 sm:col-span-2 sm:mt-0">
        <select
          {{on "change" this.change}}
          name={{@name}}
          id={{@name}}
          value={{@value}}
          class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6"
        >
          {{#each (filterSort this.suppliers "active" "name") as |supplier|}}
            <option
              value={{supplier.id}}
              selected={{eq supplier @value}}
            >{{supplier.name}}</option>
          {{/each}}
        </select>
      </div>
    </div>
  </template>
  @service store;
  element: HTMLSelectElement;
  @action
  change(event: Event) {
    if (this.args.onChange) {
      const value = event.target.value;
      this.element = event.target as HTMLSelectElement;
      const model = this.store.peekRecord('supplier', value);
      this.args.onChange(model);
      // this.args.onChange(...arguments);
    }
  }
  get suppliers() {
    if (this.args.hide_special) {
      return this.store
        .peekAll('supplier')
        .filter((supplier) => supplier.additional !== 'special');
    }
    return this.store.peekAll('supplier');
  }
  get _forceUpdate() {
    // entangle this.args.forceUpdate;
    this.args.forceUpdate;
    if (this.element) {
      this.element.value = this.args.value.id;
    }
    return null;
  }
}
